<script>
export default {
    computed: {
        profile() {
            return this.$store.getters.profile;
        }
    }
}
</script>

<template>
    <li>
        <a class="user-name font-weight-bolder mb-0 mr-1" style="color: white;">
            {{ profile.name }}
        </a>
    </li>
</template>

<style scoped lang="scss">

</style>
